import { createFileRoute } from "@tanstack/react-router";

import { requireSuperAdmin } from "@/features/auth/permissions/requireSuperAdmin";
import { CheckPage } from "@/features/mbc-admin/checks/CheckPage";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute(
  "/_auth/_app-shell/admin/mbc/checks/$checkId",
)({
  beforeLoad: ({ context }) => requireSuperAdmin(context),
  component: RouteComponent,
});

function RouteComponent() {
  const { checkId } = Route.useParams();

  usePageTitle("Check");

  return <CheckPage checkId={checkId} />;
}
